// src/components/ProtectedRoute.tsx
import { Navigate, useNavigate } from "react-router-dom";
import { ReactNode, useEffect } from "react";
import { User } from "../modules/izilife-pay/utils/database";
import useCurrentUser from "../hooks/auth/useCurrentUser";
import Loader from "../modules/izilife-pay/components/ui/Loader";

type ProtectedRouteProps = {
  children: ReactNode;
  allowedRoles: User["role"][];
};

export default function ProtectedRoute({ children, allowedRoles }: ProtectedRouteProps) {
  const { currentUser: user, loading } = useCurrentUser();
  const userRole = user?.role;
  const navigate = useNavigate();

  // Redirection uniquement après chargement et si pas d'utilisateur
  useEffect(() => {
    if (!loading && !user) {
      navigate("/login");
    }
  }, [loading, user]);

  // Pendant le chargement ou si pas d'utilisateur, on affiche le loader
  if (loading || !user) {
    return <Loader />;
  }

  if (userRole && !allowedRoles.includes(userRole)) {
    console.log("userRole", userRole);
    return <Navigate to="/denied" replace />;
  }

  return <>{children}</>;
}
